import React, { FunctionComponent } from 'react';
import type { MessageTemplateModalState } from './types';
import { MessageTemplateList } from '../../molecules/messageTemplateList'
import { MessageTemplateForm } from '../../molecules/messageTemplateForm'
import { Button } from '../../atoms/button';

type Props = {
  state: MessageTemplateModalState;
  targetName?: string;
  targetArea?: string;
  handleModalClose: () => void;
  handleFormReset: () => void;
  handleFetchedTemplate: (e: React.MouseEvent<HTMLElement>) => void;
  handleDeletedTemplate: (e: React.MouseEvent<HTMLElement>) => void;
  onChangedTitle: (v: string) => void;
  onChangedBody: (v: string) => void;
  handleSaveTemplate: () => void;
  handleUpdateTemplate: () => void;
  handlePasteTemplate: () => void;
};

export const Presentation: FunctionComponent<Props> = ({
  state,
  handleModalClose,
  handleFormReset,
  handleFetchedTemplate,
  handleDeletedTemplate,
  onChangedTitle,
  onChangedBody,
  handleSaveTemplate,
  handleUpdateTemplate,
  handlePasteTemplate,
}) => {
  const submitButtons = {
    save: {
      className: 'message-template-bottom-submit',
      value: 'テンプレートを保存する',
      onClick: handleSaveTemplate
    },
    update: {
      className: 'message-template-bottom-submit',
      value: 'テンプレートを更新する',
      onClick: handleUpdateTemplate
    },
    send: {
      className: 'message-template-bottom-send',
      value: 'テンプレートを使用する',
      onClick: handlePasteTemplate
    }
  }

  return (
    <div className="message">
      <div className="message-template">
        <div className="message-template-header">
          <div className="message-template-title">
            メッセージ・スカウトテンプレート
          </div>
          <i
            className="fas fa-times message-template-header-icon js-flex-cancellation"
            onClick={handleModalClose}
          ></i>
        </div>
        <div className="message-template-inner">
          <MessageTemplateList
            onClicked={handleFormReset}
            templates={state.templates}
            handleFetchedTemplate={handleFetchedTemplate}
            handleDeletedTemplate={handleDeletedTemplate}
            hoverStyle={state.hoverStyle}
            targetSpan={state.targetSpan}
            dustboxStyle={state.dustboxStyle}
          />
          <MessageTemplateForm
            title={state.title}
            body={state.body}
            textName="title"
            bodyName="body"
            isFocus={state.isFocus}
            onChangedTitle={onChangedTitle}
            onChangedBody={onChangedBody}
          />
        </div>
        <div className="message-template-bottom">
          <Button
            className={submitButtons[state.editingStatus].className}
            onClicked={submitButtons[state.editingStatus].onClick}
            defaultValue={submitButtons[state.editingStatus].value}
          />
        </div>
      </div>
      <div
        className="message-template-overlaybg js-flex-cancellation"
        onClick={handleModalClose}
      ></div>
    </div>
  );
};
